import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

export default function CookieBanner() {
  const { t } = useI18n();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("fluent_cookie_consent")) {
      const t = setTimeout(() => setShow(true), 800);
      return () => clearTimeout(t);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const decide = async (granted) => {
    localStorage.setItem("fluent_cookie_consent", granted ? "accepted" : "declined");
    setShow(false);
    try { await api.post("/consent", { consent_type: "cookies", granted }); }
    catch (e) { console.warn("Cookie consent log failed", e); }
  };

  if (!show) return null;
  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 md:right-auto md:left-6 rtl:md:left-auto rtl:md:right-6 md:max-w-sm z-[60] bg-ink text-white border-2 border-ink rounded-2xl p-5 shadow-[8px_8px_0px_rgba(255,107,107,0.6)] animate-pop-in"
    >
      <p className="font-cabinet font-bold text-lg">{t("cookie.title")}</p>
      <p className="text-sm text-gray-300 mt-1">
        {t("cookie.body")}{" "}
        <a href="/privacy" className="underline text-mint" data-testid="cookie-privacy-link">{t("cookie.link")}</a>{t("cookie.end")}
      </p>
      <div className="flex gap-3 mt-4">
        <button data-testid="cookie-accept" onClick={() => decide(true)}
          className="nb-btn-mint px-5 py-2 text-sm flex-1">{t("cookie.accept")}</button>
        <button data-testid="cookie-decline" onClick={() => decide(false)}
          className="nb-btn-outline px-5 py-2 text-sm flex-1">{t("cookie.decline")}</button>
      </div>
    </div>
  );
}
